import { VALUE_ENTER, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import { WizBasePopUp, WizDatasource, WizList } from '@wizeoo/akm-component-lib';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { FeiVO } from '../../../../../vo/workingdata/fei.vo';
import { PivotDeleteFieldRenderer } from './pivot-delete-field.renderer';
import { ScenarioVO } from '../../../../../vo/scenarii/scenario.vo';
import { ViewData } from '../../../../../model/view.data';
import { BaselineEngine, EM_ACTION, FeiKeyDef, WidgetLine, WizConstants } from '@wizeoo/akm-compute-lib';
import { IWidget, PivotCellEditPopData } from '../../../../../manager/widgets/i-widget';
import { UpdateRequest } from '../../../../../command/core/sync/sync.service';

@Component({
  // popUp d'édition des cellules de grid
  selector: 'pivot-cell-delete-pop',
  templateUrl: './pivot-cell-delete.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PivotCellDeletePop extends WizBasePopUp implements AfterViewInit {
  @ViewChild('fieldList') fieldList: WizList; // accesseur sur la liste des champs

  public static width: string = '400px';
  public static height: string = '350px';
  
  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER) {
      this.doDelete();
    }
    if (event.key === VALUE_ESCAPE) {
      this.hide();
    }
  }

  // rendu de la liste
  public fieldRenderer: any = PivotDeleteFieldRenderer; 

  private get popupData(): PivotCellEditPopData {
    return this.datas as PivotCellEditPopData;
  }

  private get widget(): IWidget {
    return this.popupData.widget ;
  }

  private get fei(): FeiVO {
    return this.popupData.widget.fei;
  }

  private get line(): WidgetLine {
    return this.popupData.line;
  }


  /** la DS de la liste */
  public mainDS: WizDatasource<[string, string]> = new WizDatasource<[string, string]>().build();

  /** scenario concerné */
  public scenario: ScenarioVO = null;

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  show(): void {
    
    if(this.line?.bl?.scen !== ViewData.DEFAULT_SCENARIO) {
      this.scenario = this.widget.model.scenarioEngine.getScenario(this.line.bl.v, this.line.bl.scen);
    }

    this.feedDatasources();
  }

  /** confirmation de la suppression */
  public doDelete(): void {
    // la demande
    const updateRequest: UpdateRequest = {
      fei: this.fei, 
      line: this.popupData.line,
      lines: this.popupData.pack, 
      operation: EM_ACTION.DELETE,
      fkd: this.popupData.fkd,
      value: null,
      doSplit: false,
    };
          
    this.popupData.updates = updateRequest;
    this.popupData.callback(this.popupData); // on appelle la callback avec le pack d'updates 
    this.hide();
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    const src: [string, string][] = [];
    this.fei.keys.forEach((fkd: FeiKeyDef) => {
      if (fkd.isKey) {
        src.push([this.widget.model.feiEngine.getFeiKeyDefLabel(fkd), BaselineEngine.getLabel(this.fei, this.line, fkd.fullCode, WizConstants.FIELD_LABEL)]);
      }
    });
    this.mainDS.setSource(src);
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }

  public onHide() {}

  /** libellé du scénario en cours */
  public get scenColor(): string {
    return this.scenario?.color;
  }

  /** libellé du scénario en cours */
  public get scenLabel(): string {
    return this.scenario?.trsLabel;
  }

  /**
   * affichage du libellé du scenario (sauf si main)
   */
  public get showScenLabel(): boolean {
    return !!this.scenario;
  }

}
